// extracted by mini-css-extract-plugin
export var aircallIframe = "_ik-3";
export var fabContainer = "_ik-5";
export var fabRinging = "_ik-6";
export var loadingOverlay = "_ik-4";
export var pulse = "_ik-7";
export var widgetContent = "_ik-2";
export var widgetPanel = "_ik-0";
export var widgetPanelExpanded = "_ik-1";